import React from "react";

import { getUserRole, isOperationsOnlyRole, ROLES } from "../../helpers/permissions";
import V2EmptyState from "../../v2/components/V2EmptyState";
import AdminMatrixView from "./AdminMatrixView";
import StoreManagerView from "./StoreManagerView";

/**
 * Route entry for the Store Checklists feature. Both role-specific screens
 * render the same underlying matrix (see shared/ChecklistMatrixTable) — only
 * the header and summary cards around it differ, so the split happens here
 * rather than via separate routes.
 */
export default function StoreChecklists() {
  const role = getUserRole();

  if (role === ROLES.STORE_MANAGER) {
    return <StoreManagerView />;
  }

  // Workers and unassigned Operations staff: their checklist view isn't
  // designed yet, so no store data is shown for now.
  if (isOperationsOnlyRole()) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 32 }}>
        <V2EmptyState
          title="Coming soon"
          message="Checklists for your role are coming soon."
        />
      </div>
    );
  }

  return <AdminMatrixView />;
}
